import React from 'react'

import EditQuantityOfferForm from '../../modules/QuantityOffer/components/EditQuantityOfferForm'
export default function EditQuantityOfferPage() {
  return <EditQuantityOfferForm />
}
